<script>
  export default {
    props: {
      interactive: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<template>
  <div
    class="card-base"
    :class="{
      'card-base--interactive': interactive,
    }"
  >
    <slot />
  </div>
</template>

<style lang="scss">

.card-base {
  @apply relative w-full bg-white rounded z-10 border border-gray-250;

  &--interactive {
    transition: box-shadow .2s ease(easeOutSine);

    .card-image img {
      transition: .35s ease(easeOutSine);
    }

    &:hover {
      @apply shadow-focus;

      .card-image img {
        transform: scale(1.05);
      }
    }
  }
}

</style>
